<ms-scorecast-option-group
    [optionGroup]="optionGroup"
    [event]="event"
    [showMarketHelp]="showMarketHelp"
    [eventHelpText]="eventHelpText"
    [marketTitle]="marketTitle"
    [optionTitle]="optionTitle"
    [tracking]="tracking"
    [trackingModuleType]="trackingModuleType"
    [sourceOfPick]="sourceOfPick"
    [betDetails]="betDetails"></ms-scorecast-option-group>
